// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("./Json.bs.js");
var TypeUtils = require("./types/TypeUtils.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

var include = TypeUtils.MakeOpaqueStringType({});

var decode = include.decode;

var encode = include.encode;

function parse(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great(decode, Relude_Result.toOption, param);
              }), Relude_Option.getOrThrow, param);
}

var Cursor_fromString = include.fromString;

var Cursor_toString = include.toString;

var Cursor_compare = include.compare;

var Cursor_eq = include.eq;

var Cursor_Ord = include.Ord;

var Cursor_Set = include.$$Set;

var Cursor_Map = include.$$Map;

var Cursor = {
  fromString: Cursor_fromString,
  toString: Cursor_toString,
  decode: decode,
  encode: encode,
  compare: Cursor_compare,
  eq: Cursor_eq,
  Ord: Cursor_Ord,
  $$Set: Cursor_Set,
  $$Map: Cursor_Map,
  parse: parse,
  serialize: encode
};

function parse$1(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great(Json.Decode.date, Relude_Result.toOption, param);
              }), Relude_Option.getOrThrow, param);
}

var serialize = Json.Encode.date;

var Datetime = {
  parse: parse$1,
  serialize: serialize
};

function parse$2(param) {
  return Relude_Globals.$great$great(Json.Decode.$$Option.floatFromNumberOrString, Relude_Option.getOrThrow, param);
}

function serialize$1(prim) {
  return prim;
}

var Float = {
  parse: parse$2,
  serialize: serialize$1
};

function parse$3(param) {
  return Relude_Globals.$great$great(Json.Decode.$$Option.intFromNumberOrString, Relude_Option.getOrThrow, param);
}

function serialize$2(prim) {
  return prim;
}

var Int = {
  parse: parse$3,
  serialize: serialize$2
};

function parse$4(param) {
  return Relude_Globals.$great$great(Json.Decode.$$Option.string, Relude_Option.getOrThrow, param);
}

function serialize$3(prim) {
  return prim;
}

var $$String = {
  parse: parse$4,
  serialize: serialize$3
};

exports.Cursor = Cursor;
exports.Datetime = Datetime;
exports.Float = Float;
exports.Int = Int;
exports.$$String = $$String;
/* include Not a pure module */
